import GoogleTracker from "@template/layout/Root/Trackers/Google";
import FacebookTracker from "@template/layout/Root/Trackers/Facebook";
import LinkedinTracker from "@template/layout/Root/Trackers/Linkedin";

const Trackers = () => {
  return (
    <>
      <GoogleTracker />
      <FacebookTracker />
      <LinkedinTracker />
    </>
  );
};

export default Trackers;
